import { render, staticRenderFns } from "./selectorView.vue?vue&type=template&id=4ada2108&scoped=true"
import script from "./selectorView.vue?vue&type=script&lang=js"
export * from "./selectorView.vue?vue&type=script&lang=js"
import style0 from "./selectorView.vue?vue&type=style&index=0&id=4ada2108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada2108",
  null
  
)

export default component.exports